
import { defineComponent, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Button from '@/components/ui-elements/form/Button.vue';
import Checkbox from '@/components/ui-elements/form/Checkbox.vue';
import Form from '@/components/ui-elements/form/Form';
import Input from '@/components/ui-elements/form/Input.vue';
import Modal from '@/components/modals/Modal.vue';
import { useUserStore } from '@/store';
import useStates from '@/hooks/useStates';

export default defineComponent({
	components: {
		Button,
		Checkbox,
		Form,
		Input,
		Modal,
	},
	props: {
		show: {
			required: true,
			type: Boolean,
		},
	},
	setup(props) {
		const userStore = useUserStore();
		const { path } = useRoute();
		const { push } = useRouter();

		const form = reactive({
			email: {
				rules: ['required', 'email'],
				value: '',
			},
			password: {
				rules: {
					required: 'Password is required',
				},
				value: '',
			},
			rememberMe: {
				rules: [],
				value: false,
			},
		});
		const isValid = ref(false);
		const setClose = ref(false);
		const showModal = ref(false);

		const login = async () => {
			const response = await userStore.logUserIn({
				username: form.email.value,
				password: form.password.value,
				remember: form.rememberMe.value,
			});

			if (response.success && form.email.value !== userStore.user.email) {
				const { logout } = useStates();
				logout();
				if (path === '/dashboard') {
					location.reload();
				} else {
					push({ name: 'dashboard' });
				}
			}
		};

		const setCloseModal = () => {
			setClose.value = true;
			setTimeout(() => {
				setClose.value = false;
				showModal.value = false;
			}, 1000);
		};

		watch(
			() => props.show,
			show => {
				if (show) {
					showModal.value = true;
				} else {
					setCloseModal();
				}
			}
		);

		return {
			form,
			isValid,
			login,
			setClose,
			setCloseModal,
			showModal,
		};
	},
});
